export const evaluationCategories = [
    {
      title: "Zaman yönetimi ve iş teslimatları",
      description:
        "Juniorın görevleri zamanında ve kaliteli şekilde tamamlayıp tamamlamadığı. Bu başlık, bir kişinin iş disiplini ve güvenilirliğini gösterir.",
    },
    {
      title: "İletişim ve takım çalışması",
      description:
        "Takım içindeki uyum, işbirliği, iletişim becerileri. Ekip içinde etkili iletişim kurabilme, geri bildirimleri almak ve vermek gibi unsurları kapsar.",
    },
    {
      title: "Problem çözme ve yaratıcılık",
      description:
        "Juniorın karşılaştığı teknik veya iş problemleriyle nasıl başa çıktığı, yaratıcı çözümler geliştirme yeteneği.",
    },
    {
      title: "Geri bildirim ve kişisel gelişim",
      description:
        "Takım içindeki uyum, işbirliği, iletişim becerileri. Ekip içinde etkili iletişim kurabilme, geri bildirimleri almak ve vermek gibi unsurları kapsar.",
    },
    {
      title: "Bağımsız Çalışabilme ve İnisiyatif",
      description:
      "Junior’ın bağımsız çalışabilme becerisi ve işin ötesine geçme isteği. Kendi başına görevleri tamamlayabilme ve yeni sorumluluklar üstlenme yeteneği."
    }
  ];
  export default evaluationCategories